import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
import SortableTable2 from '../table/SortableTable2';
import ShortCourseAnalyticsView from './ShortCourseAnalyticsView';

const propTypes = {
    shortCourses: PropTypes.array,
    onShortCourseClick: PropTypes.func.isRequired,
    shortCourseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
const defaultProps = {
    shortCourses: [],
    shortCourseId: null,
    projectId: null
};

class ShortCourseListAnalyticsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLeftColumn: true
        };
        this.toggleShowLeftColumn = this.toggleShowLeftColumn.bind(this);
    }

    toggleShowLeftColumn(e) {
        this.setState({ showLeftColumn: !this.state.showLeftColumn });
    }

    render() {
        return (
            <Row className="main-content-nav">
                <div className="main-content col-12">
                    <Row>
                        <div
                            className="col-sm-12 col-md-4 col-lg-3 padding-all-md"
                            style={ this.state.showLeftColumn ? {} : { display: "none" } }
                        >
                            <h2
                                className="large-heading margin-bottom-lg"
                                role="button"
                                onClick={this.toggleShowLeftColumn}
                            >
                                <span className="fa fa-caret-down margin-right-sm" aria-hidden="true" />
                                {Strings['en'].analytics.overview.short_course.SELECTOR_SECTION_TITLE}
                            </h2>
                            <SortableTable2
                                classNameTable="font-size-md"
                                rows={this.props.shortCourses}
                                selectedRowKey={this.props.shortCourseId}
                                onRowClick={this.props.onShortCourseClick}
                                defaultSort={{ key: 'title', type: 'string', asc: true }}
                                displayColumnCallbacks={{
                                    'course_instance_count': (num) => StringUtil.numberToLocaleString(num),
                                    'student_count': (num) => StringUtil.numberToLocaleString(num),
                                }}
                                columns={[
                                        {
                                            displayName: Strings['en'].analytics.overview.short_course.SELECTOR_TITLE_HEADING,
                                            key: 'title',
                                            type: 'string',
                                            width: '50%'
                                        },
                                        {
                                            displayName: Strings['en'].analytics.overview.short_course.SELECTOR_CI_HEADING,
                                            key:'course_instance_count',
                                            type: 'int',
                                            width: '30%'
                                        },
                                        {
                                            displayName: Strings['en'].analytics.overview.short_course.SELECTOR_STUDENTS_HEADING,
                                            key: 'student_count',
                                            type: 'int',
                                            width: '20%'
                                        }
                                    ]}
                            />
                        </div>
                        <div className={ this.state.showLeftColumn ? "col-sm-12 col-md-8 col-lg-9 padding-all-md" : "col-12 padding-all-md" }>
                            <div>
                                {(!this.state.showLeftColumn) &&
                                    <h2
                                        className="large-heading margin-bottom-lg"
                                        role="button"
                                        onClick={this.toggleShowLeftColumn}
                                    >
                                        <span className="fa fa-caret-right margin-right-sm" aria-hidden="true" />
                                        {Strings['en'].analytics.overview.short_course.SELECTOR_SECTION_TITLE}
                                    </h2>
                                }
                                {(!!this.props.shortCourseId) ?
                                    <ShortCourseAnalyticsView
                                        shortCourseId={this.props.shortCourseId}
                                        projectId={this.props.projectId}
                                        channelId={this.props.channelId}
                                    />
                                    :
                                    <h2 className="heading-md text-centered margin-top-lg">
                                        {Strings['en'].analytics.overview.short_course.SELECTION_PROMPT}
                                    </h2>
                                }
                            </div>
                        </div>
                    </Row>
                </div>
            </Row>
        );
    }
}

ShortCourseListAnalyticsView.propTypes = propTypes;
ShortCourseListAnalyticsView.defaultProps = defaultProps;

export default ShortCourseListAnalyticsView;